/**
 * Controls how scripts are displayed across the app.
 *
 * "responsive" → inline text on desktop, tooltip on mobile
 * "always-inline" → inline text everywhere
 * "always-tooltip" → tooltip (speech bubble) everywhere
 */
export type AgentScriptMode = "responsive" | "always-inline" | "always-tooltip";

export const AGENT_SCRIPT_MODE: AgentScriptMode = "responsive";

export const MOBILE_BREAKPOINT = 560;
